import Autocomplete from './Autocomplete';
import Checkbox from './Checkbox';
import Button from './Button';
import ButtonGroup from './ButtonGroup';
import IconButton from './IconButton';
import Snackbar from './Snackbar';
import Alert from './Alert';
import FormControlLabel from './FormControlLabel';
import Divider from './Divider';
import Select from './Select';
import Slider from './Slider';
import OutlinedInput from './OutlinedInput';
import PickersCalendarHeader from './PickersCalendarHeader';

const overrides = {
    Autocomplete,
    Checkbox,
    Button,
    ButtonGroup,
    IconButton,
    Snackbar,
    Alert,
    FormControlLabel,
    Divider,
    Select,
    Slider,
    OutlinedInput,
    PickersCalendarHeader,
};

export default (theme, colors) => ({
    components: {
        ...Object.entries(overrides).reduce(
            (acc, [key, value]) => ({
                ...acc,
                [`Mui${key}`]: { styleOverrides: value(theme, colors) },
            }),
            {}
        ),
    },
});
